import wrapperHOC from "@Utils/wrapperHOC";
import CustomLink from "@Components/CustomLink";
import styles from "./TrustPilotDynamicWidget.module.scss";
import { useRef } from "react";
import { useLazyCallback } from "hooks/useLazyCallback";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";

const TrustPilotDynamicWidget = ({
  width = "240px",
  height = "116px",
  templateId = "53aa8807dec7e10d38f59f32",
  margin = "0 0 -4px 0",
}) => {
  const containerRef = useRef(null);
  const nonce = useSelector(({ appData }: AppState) => appData.nonce, shallowEqual);
  const loadScript = () => {
    if (window.Trustpilot) {
      window?.Trustpilot?.loadFromElement(containerRef.current, true);
      return;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.nonce = nonce;
    script.onload = () => {
      window?.Trustpilot?.loadFromElement(containerRef.current, true);
    };
    document.body.appendChild(script);
  };

  useLazyCallback(
    loadScript,
    {
      rootMargin: "300px 0px 300px 0px",
    },
    containerRef,
    [],
  );

  return (
    <div className={styles.container} style={{ margin, width, height }}>
      <div
        ref={containerRef}
        className="trustpilot-widget"
        data-locale="en-GB"
        data-template-id={templateId}
        data-businessunit-id="579c87e70000ff000592e82f"
        data-style-height={height}
        data-style-width={width}
        data-testid="Trustpilot-logo"
      >
        <CustomLink
          rel="noreferrer"
          href="https://uk.trustpilot.com/review/amberstudent.com"
          target="_blank"
          isExternal
        >
          {" "}
        </CustomLink>
      </div>
    </div>
  );
};

export default wrapperHOC(TrustPilotDynamicWidget, {
  componentName: "TrustPilotDynamicWidget",
  showForChina: true,
});
